import { render, staticRenderFns } from "./overall-view-course.vue?vue&type=template&id=d35f6644&scoped=true&"
import script from "./overall-view-course.vue?vue&type=script&lang=js&"
export * from "./overall-view-course.vue?vue&type=script&lang=js&"
import style0 from "./overall-view-course.vue?vue&type=style&index=0&id=d35f6644&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35f6644",
  null
  
)

export default component.exports